import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EmptyData } from "../../../../components/empty/emptyData";
import { useLeasingRegister } from "./useLeasingRegister";
import { FilterLeasingRegister } from "./FilterLeasingRegister";
import { AddLeasingRegisterModal } from "./AddLeasingRegisterModal";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetLeasingRegisterListFilteredQuery } from "../../../../redux/api/mechanization/leasingRegisterApi";
import i18n from "i18next";
import { EntLeasingRegister } from "../../../../models/mechanization/leasingRegister";
import { EntLeasingRegisterFilter } from "../../../../models/filters/leasingRegisterFilter";
import { useGetReportByLeasingMutation } from "../../../../redux/api/mechanization/reportDepartmentMechApi";
import ReportDepartmentMechModal from "../reportDepartmentMech/ReportDepartmentMechModal";

enum FormField {
  transportIds,
}

export const LeasingRegister = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntLeasingRegister>(new EntLeasingRegister());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation();

  const [getLeasingReport] = useGetReportByLeasingMutation();
  const [getLeasingRegisters] = useLazyGetLeasingRegisterListFilteredQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntLeasingRegister, EntLeasingRegisterFilter>({
	initialFilter: new EntLeasingRegisterFilter(),
	query: getLeasingRegisters
  });

  const { onAddLeasingRegister, onEditLeasingRegister, onDeleteLeasingRegister } = useLeasingRegister(modal, () => {
	searchHandleClick();
  });
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isMechAvailable = storedData.some((route: any) => (route.alias === "/departments/mechanization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntLeasingRegister) => {
	setSelectedItem(item);
	setShowModal(true);
  };


  const setEntityFromFields = (): EntLeasingRegisterFilter => {
	let filt: EntLeasingRegisterFilter = _.clone(filter);
	filt.transportIds = form.getFieldValue(FormField.transportIds) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.transportIds, value: null },
	]);
  };

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  };

  const getReport = async (payload: { languageEnum: string }): Promise<Blob> => {
	return await getLeasingReport(payload).unwrap();
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('mechanisation.leasing.operator_leasing') }</th>
		  <th>{ t('mechanisation.leasing.leasing_agreement') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
			<tr key={ item.id }>
			  <td>{ ++index }</td>
			  <td>{ i18n.language === 'ru' ? item.operator?.nameRu : item.operator?.nameKy }</td>
			  <td>{ item.issueDate }</td>
			  <td>
				<Flex gap="small">
				  { access && access.methodPut && (
					<Tooltip title={ t('general.edit') }>
					  <Button className='btn_edit' onClick={ () => {
						openAddModal(item)
					  } } type="primary" shape="circle" icon={ <EditOutlined/> }/>
					</Tooltip>
				  ) }
				  { access && access.methodDelete && (
					<Tooltip title={ t('general.delete') }>
					  <Button className='btn_edit' danger onClick={ () => {
						onDeleteLeasingRegister(item)
					  } } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
					</Tooltip>
				  ) }
				</Flex>
			  </td>
			</tr>
		  )) :
		  <tr>
			<td colSpan={ 7 }>
			  <EmptyData/>
			</td>
		  </tr> }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.leasing') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntLeasingRegister())
		} }>
		  { t('mechanisation.leasing.add_leasing') }
		</Button>
	  ) }
	  { isMechAvailable && (
		<Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> }
				onClick={ () => setShowReportModal(true) }>
		  { t('general.generate_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterLeasingRegister onSearch={ searchHandleClick } onReset={ () => {
		  clearFields();
		  searchHandleClick()
		} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddLeasingRegisterModal
		leasingRegister={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditLeasingRegister : onAddLeasingRegister }
	  />
	  <ReportDepartmentMechModal
		type={ 'leasing' }
		title={ t('reports.report_by_leasing') }
		getReport={ getReport }

		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  );
};
